export default "__VITE_ASSET__BSUpAney__"